import { GridCellLabel } from '../types';

export function getLabels(translateFn: Function, arrayValues: number[], getLabel: Function): GridCellLabel[] {
  const labels: GridCellLabel[] = [];
  for (const item of arrayValues) {
    labels.push({
      label: getLabel(item, translateFn),
      value: item,
    });
  }
  return labels.sort((a, b) => a.label.localeCompare(b.label));
}
